import {PageType} from "../models/types";
import * as companyData from "./company-data";
import * as staticUrls from "./static-urls";
import * as staticImages from "./static-images";
import * as CookieConsent from 'vanilla-cookieconsent';

/**
 * INFORMACJE O TYM CO WJECHAĆ MOŻE DO HELMETA
 * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
 * @param {Object} bodyAttributes: {"className": "root"}
 * @param {String} defaultTitle: "Default Title"
 * @param {Boolean} defer: true
 * @param {Boolean} encodeSpecialCharacters: true
 * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
 * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
 * @param {Array} meta: [{"name": "description", "content": "Test description"}]
 * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
 * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
 * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
 * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
 * @param {String} title: "Title"
 * @param {Object} titleAttributes: {"itemprop": "name"}
 * @param {String} titleTemplate: "MySite.com - %s"
 */

/**
 * PRZYGOTOWYWANIE TYTUŁU STRONY OPISU
 * @param {PageType} pageType TYP STRONY
 * @returns {[string , string , string]} (pageTitle,pageDescription,pageCanonicalLink)
 */
function prepareWebsiteBasicData(pageType:PageType): [string,string,string] {
  // CANONICAL LINK
  const baseWebsiteUrl: string = companyData.FAKTUROMANIA_APP_COMPANY_WEBSITE;
  switch (pageType) {
    case PageType.BiuroRachunkowePage:
      return [
        "Biuro rachunkowe online - Fakturomania Sp. z o.o.",
        "Zastanawiasz się czy prowadzenie firmy bez ZUS jest możliwe? Oczywiście! Załóż spółkę z o.o. i skorzystaj z naszego programu do pełnej księgowośći online.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_BIURO_RACHUNKOWE_PAGE_URL}`
      ];
    case PageType.CennikPage:
      return [
        "Księgowość online - pełna księgowość z fakturomania.pl",
        "Cennik usług fakturomania.pl. Sprawdź co zawiera każdy z oferowanych przez nas pakietów i wybierz wybierz optymalne rozwiązanie.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL}`
      ];
    case PageType.CookiesPage:
      return [
        "Polityka Cookies - Fakturomania Sp. z o.o.",
        "Polityka Cookies. Niniejsza Polityka Prywatności określa zasady przechowywania i dostępu do informacji na urządzeniach Użytkownika za pomocą plików Cookies, służących realizacji usług świadczonych drogą elektroniczną.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL}`
      ];
    case PageType.DotacjePage:
      return [
        "Projekt POIG 8.2 - Fakturomania Sp. z o.o.",
        "Fakturomania - informacje o dofinansowaniu przyznanym w ramach działania 8.2 Innowacyjna Gospodarka.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_DOTACJE_PAGE_URL}`
      ];
    case PageType.FaqPage:
      return [
        "Najczęściej zadawane pytania - Fakturomania Sp. z o.o.",
        "FAQ - najczęściej zadawane pytania. Dowiedz się więcej o tym co umożliwia nasza aplikacja. Zbiór pytań i odpowiedzi na najczęściej pojawiające się pytania",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_FAQ_PAGE_URL}`
      ];
    case PageType.FunkcjePage:
      return [
        "Funkcje - Fakturomania Sp. z o.o.",
        "Fakturomania.pl - Program do pełnej księgowości online. Zobacz funkcje i możliwości programu.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_FUNKCJE_PAGE_URL}`
      ];
    case PageType.KontaktPage:
      return [
        "Kontakt - Fakturomania Sp. z o.o.",
        "Kontakt - fakturomania.pl. Skontaktuj się z nami, chętnie odpowiemy na Twoje pytania. Jesteśmy do Twojej dyspozycji!.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL}`
      ];
    case PageType.NaszZespolPage:
      return [
        "Pełna księgowość spółki z o.o. online, firma bez zus (jak nie płacić) – Fakturomania Sp. z o.o.",
        "Zastanawiasz się czy prowadzenie firmy bez ZUS jest możliwe? Oczywiście! Załóż spółkę z o.o. i skorzystaj z naszego programu do pełnej księgowośći online.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_NASZ_ZESPOL_PAGE_URL}`
      ];
    case PageType.PorownaniePakietowPage:
      return [
        "Pełna księgowość spółki z o.o. online, firma bez zus (jak nie płacić) – Fakturomania Sp. z o.o.",
        "Zastanawiasz się czy prowadzenie firmy bez ZUS jest możliwe? Oczywiście! Załóż spółkę z o.o. i skorzystaj z naszego programu do pełnej księgowośći online.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_POROWNANIE_PAKIETOW_PAGE_URL}`
      ];
    case PageType.RegulaminPage:
      return [
        "Regulamin Serwisu Internetowego - Fakturomania Sp. z o.o.",
        "Regulamin serwisu fakturomania.pl. Regulamin określna zasady świadczenia usług przez system informatyczny fakturomania.pl",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL}`
      ];
    case PageType.ZakladanieSpolekZooPage:
      return [
        "Zakładanie spółek online - Fakturomania Sp. z o.o.",
        "Zastanawiasz się czy prowadzenie firmy bez ZUS jest możliwe? Oczywiście! Załóż spółkę z o.o. i skorzystaj z naszego programu do pełnej księgowośći online.",
        `${baseWebsiteUrl}${staticUrls.FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL}`
      ];
    case PageType.KalkulatorWynagrodzenPage:
    case PageType.LandingPage:
    case PageType.NotFoundPage:
    default:
      return [
        "Pełna księgowość spółki z o.o. online, firma bez zus – Fakturomania Sp. z o.o.",
        "Zastanawiasz się czy prowadzenie firmy bez ZUS jest możliwe? Oczywiście! Załóż spółkę z o.o. i skorzystaj z naszego programu do pełnej księgowośći online.",
        `${baseWebsiteUrl}`
      ];
  }
}

/** UNIVERSAL STATIC ELEMENTS */

const FAKTUROMANIA_LOGO_AND_NAME_PATH: string = staticImages.FAKTUROMANIA_LOGO_AND_NAME_STATIC_FOR_SEO;
const FAKTUROMANIA_FAVICON_PATH: string = staticImages.FAKTUROMANIA_FAVICON_STATIC_FOR_SEO;

/** UNIVERSAL META ELEMENTS */

const UniversalConstantMetaElements: any[] = [
  {name: "robots", content: "noodp"}
];

function prepareUniversalMetaElements(pageType: PageType): any[] {
  switch (pageType) {
    case PageType.RegulaminPage:
    case PageType.CookiesPage:
      return [
        {name: "robots", content: "noindex"}
      ];
    default:
      return UniversalConstantMetaElements;
  }
}

function prepareMetaElements(pageType: PageType, pageDescription: string): any[] {
  return [
    {name: "description", content: pageDescription},
    ...prepareUniversalMetaElements(pageType)
  ];
}

/** META FACEBOOK */

const FacebookConstantMetaElements: any[] = [
  {name: "og:site_name", content: "Fakturomania"},
  {name: "og:image", content: FAKTUROMANIA_LOGO_AND_NAME_PATH},
  {name: "og:type", content: "website"},
  {name: "fb:app_id", content: "556600714415943"}
];

function prepareFacebookMeta(pageTitle: string, pageDescription: string, pageCanonicalLink: string): any[] {
  return [
    {name: "og:title", content: pageTitle},
    {name: "og:description", content: pageDescription},
    {name: "og:url", content: pageCanonicalLink},
    ...FacebookConstantMetaElements
  ];
}

/** META TWITTER */

const TwitterConstantMetaElements: any[] = [
  {name: "twitter:site", content: "@Fakturomania"},
  {name: "twitter:card", content: "summary"},
  {name: "twitter:image", content: FAKTUROMANIA_LOGO_AND_NAME_PATH},
];

function prepareTwitterMeta(pageTitle: string, pageDescription: string): any[] {
  return [
    {name: "twitter:title", content: pageTitle},
    {name: "twitter:description", content: pageDescription},
    ...TwitterConstantMetaElements
  ];
}

/** LINK DATA */

/** CZCIONKI */

const GOOGLE_FONTS: any = {
  rel: "stylesheet",
  href: "https://fonts.googleapis.com/css?family=Raleway:400,300,500,700,900|Roboto:400,100,300,500,700",
  type: "text/css"
};

/** POZOSTAŁE ELEMENTY */
const LINK_PUBLISHER: any = {rel: "publisher", href: "https://www.google.com/+FakturomaniaPl"};
const LINK_FAVICON: any = {rel: "icon", href: FAKTUROMANIA_FAVICON_PATH, type: "image/png"};

/** STAŁE ELEMENTY DO LINK */

const LINK_CONSTANT_DATA: any[] = [GOOGLE_FONTS,LINK_PUBLISHER,LINK_FAVICON];

/** PRZYGOTOWYWANIE DATA DO LINK */

function prepareLinkData(pageCanonicalLink: string): any[] {
  return [
    {rel: "canonical", href: pageCanonicalLink},
    ...LINK_CONSTANT_DATA
  ];
}

/** SCRIPT DATA */

/** SEO DODATEK DO SCRIPT */
const SEO_ADDITION_SCRIPT: any = {
  type: "application/ld+json",
  innerHTML: JSON.stringify(
    {
      "@context": "http://schema.org",
      "@type": "AccountingService",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_FULL,
        "streetAddress": companyData.FAKTUROMANIA_APP_COMPANY_STREET_FULL,
        "postalCode": companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CODE,
        "addressRegion": companyData.FAKTUROMANIA_APP_COMPANY_VOIVODESHIP
      },
      "name": companyData.FAKTUROMANIA_APP_COMPANY_NAME,
      "email": companyData.FAKTUROMANIA_APP_COMPANY_EMAIL,
      "telephone": companyData.FAKTUROMANIA_APP_COMPANY_PHONE,
      "vatID": companyData.FAKTUROMANIA_APP_COMPANY_NIP,
      "image": FAKTUROMANIA_LOGO_AND_NAME_PATH
    }
  )
};

const FRESHCHAT_SCRIPT_ADDITION_SCRIPT: any = {
  type: "text/javascript",
  src: "https://wchat.freshchat.com/js/widget.js"
};

const FRESHCHAT_SCRIPT_LOADER_ADDITION_SCRIPT: any = {
  type: "text/javascript",
  innerHTML: `
    function initFreshChat() {
      window.fcWidget.init({
        token: 'dfbdeb3f-f98c-48b6-be5b-43247a96a9c8',
        host: 'https://wchat.freshchat.com',
        siteId: 'FAKTUROMANIA_LANDING_PAGE',
        locale: 'pl',
        config: {
          // INFORMACJE DO WYŚWIETLANIA O AGENCIE
          agent: {
            // INFO CZY CHOWAĆ IMIE AGENTA => JEŻELI DISABLE, TO BĘDZIE NAZWA KANAŁU
            hideName: true,
            // INFO CZY CHOWAĆ FOTO AGENTA
            hidePic: true,
            // INFO CZY CHOWAĆ BIOGRAFIE AGENTA
            hideBio: true
          },
          // INFORMACJA CZY CHOWAĆ FAQ
          hideFAQ: false,
          // INFO CZY FAK MA BYĆ DOMYŚLNĄ ZAKŁADKĄ
          showFAQOnOpen: false,
          // USTAWIENIA PODSTAWOWE WIDGETA
          headerProperty: {
            // NAZWA APLIKACJI
            appName: 'Fakturomania',
            // KOLOR TŁA
            backgroundColor: '#45a4ec',
            // KOLOR LITEREK
            foregroundColor: '#fff'
          },
          // ZAWARTOŚĆ WIDGETA
          content: {
            placeholders: {
              // TEKST DO UDZIELANIA ODPOWIEDZI
              reply_field: 'Odpowiedz',
              // TEKST DO WYSZUKIWANIA W FAQ
              search_field: 'Wyszukaj',
              // TEKST DO CSAT
              csat_reply: 'Podziel się z nami Swoją opinią'
            },
            // NAZWY PRZYCISKÓW
            actions: {
              // CZAT ZAKŁADKA
              tab_chat: 'CZAT',
              // FAQ ZAKŁADKA
              tab_faq: 'BAZA WIEDZY',
              // POWIADOMENIA CHROME
              push_notify_yes: 'Tak',
              push_notify_no: 'Nie',
              // CSAT
              csat_yes: 'Tak',
              csat_no: 'Nie',
              csat_submit: 'Wyślij'
            },
            // NAGŁÓWKI
            headers: {
              // NAGŁÓWEK GŁÓWNY W CZACIE
              chat: 'Czat',
              // SUBTITLE PONIŻEJ NAGŁÓWKA GŁÓWNEGO NA CZACIE
              chat_help: 'Napisz do nas, jeśli masz pytania',
              // KOMUNIKATY OFFILE I ONLINE DO CZATU ODNOŚNIE TERMINU ODPOWIEDZI
              channel_response: {
                offline: 'Odpowiadamy w godzinach pracy',
                online: {
                  minutes: {
                    one: 'Zazwyczaj odpowiada kilka minut',
                    more: 'Zazwyczaj odpowiada kilka minut'
                  },
                  hours: {
                    one: 'Zazwyczaj odpowiada kilka godzin',
                    more: 'Zazwyczaj odpowiada kilka godzin'
                  }
                }
              },
              // NAGŁÓWEK GŁÓWNY W FAQ
              faq: 'Baza Wiedzy',
              // SUBTITLE PONIŻEJ NAGŁÓWKA GŁÓWNEGO W FAQ
              faq_help: 'Przeszukaj bazę wiedzy',
              // INFORMACJA ŻE BAZA WIDZY JEST NIEDOSTĘPNA
              faq_not_available: 'Baza Wiedzy jest niedostępna',
              // INFORMACJA JAK NIE UDAŁO SIĘ ODNALEŹĆ ARTYKUŁÓW NA DANY TEMAT
              faq_search_not_available: 'Nie odnaleziono materiałów na temat: {{query}}',
              // PYTANIE DO USERA, CZY DANY MATERIAŁ Z FAQ WYDAŁ MU SIĘ POMOCNY
              faq_useful: 'Czy ten materiał był pomocny?',
              // PODZIĘKOWANIE ZA UDZIELIENIE OPINI NA TEMAT DANEGO MATERIAŁU
              faq_thankyou: 'Dziękujemy za Twoją opinię',
              // TREŚĆ PRZYCISKU DO PISANIA DO NAS Z ZAKŁADKI FAQ
              faq_message_us: 'Napisz do nas',
              // TREŚĆ KOMUNIKATU PYTAJĄCEGO O POWIADOMIENIA PRZEGLĄDARKI O WIADOMOŚCIACH
              push_notification: 'Zezwalaj na otrzymywanie powiadomień?',
              // CSAT
              csat_question: 'Czy Twoja sprawa została rozwiązana?',
              csat_yes_question: 'Jak oceniasz tę rozmowę?',
              csat_no_question: 'Czy coś Twoim zdaniem można poprawić?',
              csat_thankyou: 'Dziękujemy za Twoją opinię',
              csat_rate_here: 'Prześlij tutaj swoją ocenę'
            }
          }
        },
        disableEvents: true
      });
    };
    
    function initialize(i,t){var e;i.getElementById(t)?initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,e.src="https://wchat.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}function initiateCall(){initialize(document,"freshchat-js-sdk")}window.addEventListener?window.addEventListener("load",initiateCall,!1):window.attachEvent("load",initiateCall,!1);
  `
};

/** GOOGLE ANALITICS */

/** STAŁE ELEMENTY DO SCRIPT */

const SCRIPT_CONSTANT_DATA: any[] = [
  SEO_ADDITION_SCRIPT,
  FRESHCHAT_SCRIPT_ADDITION_SCRIPT,
  FRESHCHAT_SCRIPT_LOADER_ADDITION_SCRIPT
];

/** PRZYGOTOWYWANIE PRAWIDŁOWYCH DANYCH DO HEADERA STRONY */

export function prepareHelmetData(pageType: PageType): HelmetProps {
  // IMPORT FIX
  console.log(`CookieConsent: initializeCookie`,CookieConsent)

  // TITLE I DESCRIPTION
  const [pageTitle,pageDescription,pageCanonicalLink] = prepareWebsiteBasicData(pageType);

  // PRZYGOTOWYWANIE DANYCH DO HEADA
  const META_DATA: any[] = [
    ...prepareMetaElements(pageType,pageDescription),
    ...prepareFacebookMeta(pageTitle,pageDescription,pageCanonicalLink),
    ...prepareTwitterMeta(pageTitle,pageDescription)
  ];

  // PRZYGOTOWYWANIE LINK DATA
  const LINK_DATA: any[] = [
    ...prepareLinkData(pageCanonicalLink)
  ];

  // ZWRACANIE PRZYGOTOWANYCH DANYCH
  return {
    title: pageTitle,
    meta: META_DATA,
    link: LINK_DATA,
    script: SCRIPT_CONSTANT_DATA
  };
}


// WEBPACK FOOTER //
// ./src/constants/helmet-data.ts